export const dashBoardPaths = {
  analysis: "analysis",
  customers: "customers",
  reviews: "reviews",
  setting: "setting",
} as const;

export type IDashBoardPaths =
  typeof dashBoardPaths[keyof typeof dashBoardPaths];
